<template>
    <div>
        <MotorsModal
            v-if="siteNameSelected"
            :site-name="siteNameSelected"
        ></MotorsModal>
        <SitesModal
            v-else
            @selectedSite="selectedSite"
        >
        </SitesModal>
        <div>
            <el-button
                class="close-import-button"
                @click="cancel"
            >
                {{ cancelButtonText }}
            </el-button>
        </div>
    </div>
</template>

<script>
import MotorsModal from './motorsModal.vue';
import SitesModal from './sitesModal.vue';
import { mapGetters } from 'vuex';
export default {

    name: 'importMotorModal',

    components:{
        MotorsModal,
        SitesModal
    },

    data () {
        return {
            siteNameSelected: ''
        };
    },

    computed:{
        ...mapGetters([
            'getText',
        ]),
        cancelButtonText(){
            return this.siteNameSelected ? this.getText('return_button') : this.getText('close_button');
        }
    },

    methods:{
        closeModal(){
            this.$emit('close');
        },
        selectedSite(siteName){
            this.$set(this, 'siteNameSelected', siteName);
        },
        cancel(){
            if(this.siteNameSelected){
                this.$set(this, 'siteNameSelected', '');
            } else {
                this.closeModal();
            }
        }
    }
};
</script>

<style lang="scss">
.import-motor-dialog{
    .el-dialog__title{
        margin-left: 0.5rem;
    }
}
.import-motor{
    &__content{
        max-height: 300px;
        overflow-y: auto;
        &__card{
            margin-top: 1rem;
            &__container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                &__imported-from{
                    font-size: 12px;
                    margin-left: 2rem;
                    padding: 0.5rem 1rem;
                    border-radius: 3rem;
                    color: white;
                }
                &__import-btn:hover{
                    border-color: #C4D600;
                    background-color: #C4D600;
                    color: white;
                }
            }
        }
    }
}
.el-button.close-import-button{
    background-color: #C4D600;
    color: white;
    width: 100%;
    border: none;
    margin-top: 4rem;
}
.el-button.close-import-button:hover{
    background-color: #C4D600;
    color: white;
}
.el-button.close-import-button:active{
    background-color: #C4D600;
    color: white;
}
.ns-paginate.import-motor-paginate{
    .reloadBtn{
        display: none;
    }
    .blockSearch{
        span{
            display: none;
        }
    }
    .blockFlex{
        .el-button.el-button--primary{
            border: none;
            background-color: #C4D600;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/import-motor-modal/Index.vue